// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bubble{word-break:break-word;border-radius:12px;font-size:14px;display:inline-block;background-color:#efefef;white-space:pre-wrap}.list-group.vertical-steps>.list-group-item{border:none;border-left:3px solid #ece5dd;box-sizing:border-box;border-radius:0;counter-increment:step-counter;padding-left:40px;padding-right:0;padding-bottom:50px;padding-top:0;margin-top:-25px}.list-group.vertical-steps>.list-group-item:first-child{margin-top:0}.link-white a{color:#fff!important}", ""]);
// Exports
module.exports = exports;
